<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMSSearch w3-hide-print">
        <div>
          <header>
            <h2>Portolio</h2>
          </header>
        </div>
        <div class="w3-right-align">
          <router-link to="/cms/portfolio-detail" class="w3-button w3-teal vmiddle" style="font-size:10pt;">
            New Item
          </router-link>
        </div>
      </div>
      <div class="inputCard">
        <header>Portfolio Items</header>
        <div class="content w3-padding-8">
          <!-- pagination -->
          <div class="pagination">
            <div class="w3-right">
              <button class="paginationButton" @click="gotoPage('-1')"><i class="fa fa-chevron-left"></i></button>
              <button class="paginationButton" @click="gotoPage(index)" v-for="index in Math.ceil(this.state.siteData.content.portfolio.items.length / 36)" :key="index" :class="activePage === index ? 'active':''">{{index}}</button>
              <button class="paginationButton" @click="gotoPage('+1')"><i class="fa fa-chevron-right"></i></button>
            </div>
          </div>
          <div class="portfolioContentGrid">
            <article class="inputCard" v-for="(portfolioItem, index) in portfolio" :key="index">
              <header class="cardTitle w3-center">{{portfolioItem.title}}</header>
              <template v-if="portfolioItem.images && portfolioItem.images.length > 0">
                <div class="cardImage" :style="{'background-image': 'url(' + portfolioItemImage(portfolioItem.images[0].src) + ')'}"></div>
              </template>
              <main class="w3-padding-8" style="height:100px; overflow:hidden; border-bottom: 1px solid #ccc; border-top: 1px solid #ccc;" v-html="portfolioItem.description"></main>
              <div class="row2 w3-padding-top">
                <div class="w3-container">
                  <b>Category:</b>
                </div>
                <div class="w3-container w3-right-align">
                  {{categoryName(portfolioItem.category)}}
                </div>
              </div>
              <div class="row2">
                <div class="w3-container">
                  <b>Status:</b>
                </div>
                <div class="w3-container w3-right-align" style="text-transform:capitalize;">
                  {{portfolioItem.status}}
                </div>
              </div>
              <div class="w3-container">
                <div class="row2">
                  <router-link tag="button" :to="'/cms/portfolio-detail/' + portfolioItem.url" class="w3-button w3-small w3-teal w3-block">Edit</router-link>
                  <button class="w3-button w3-small w3-red w3-block" @click="deletePortfolioItem(portfolioItem.url)">Delete</button>
                </div>
              </div>
            </article>
          </div>
          <!-- pagination -->
          <div class="pagination">
            <div class="w3-right">
              <button class="paginationButton" @click="gotoPage('-1')"><i class="fa fa-chevron-left"></i></button>
              <button class="paginationButton" @click="gotoPage(index)" v-for="index in Math.ceil(this.state.siteData.content.portfolio.items.length / 36)" :key="index" :class="activePage === index ? 'active':''">{{index}}</button>
              <button class="paginationButton" @click="gotoPage('+1')"><i class="fa fa-chevron-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsportfolio',
  data() {
    return {
      state: dataStore.state,
      activePage: 1
    }
  },
  computed: {
    portfolio() {
      if (this.activePage) {
        return this.state.siteData.content.portfolio.items.slice((this.activePage - 1) * 36, this.activePage * 36)
      } else {
        return this.state.siteData.content.portfolio.items.slice(0, 36)
      }
    }
  },
  methods: {
    gotoPage(page) {
      if (page === '-1') {
        if (this.activePage > 1) {
          this.activePage--
        }
      } else if (page === '+1') {
        if (this.activePage < Math.ceil(this.state.siteData.content.portfolio.items.length / 9)) {
          this.activePage++
        }
      } else {
        this.activePage = page
      }
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deletePortfolioItem(url) {
      let itemIndex = this.state.siteData.content.portfolio.items.findIndex(savedPortfolioItem => savedPortfolioItem.url === url)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.portfolio.items[itemIndex].title + ' portfolio item?')) {
          this.state.siteData.content.portfolio.items.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    },
    portfolioItemImage(img) {
      if (img) {
        return encodeURI(img)
      } else {
        return 'https://levelsevenstudio.com/api/images/levelsevenstudio.com/placeholder-square.png'
      }
    },
    categoryName(id) {
      let itemIndex = this.state.siteData.content.portfolio.categories.findIndex(savedCategory => savedCategory.id === id)
      if (itemIndex > -1) {
        return this.state.siteData.content.portfolio.categories[itemIndex].title
      } else {
        return 'None'
      }
    },
    findCategoryBySlug(categoryName) {
      let searchSlug = slug(categoryName)
      let itemIndex = this.state.siteData.content.portfolio.categories.findIndex(savedCategory => savedCategory.slug === searchSlug)
      if (itemIndex > -1) {
        return this.state.siteData.content.portfolio.categories[itemIndex]
      } else {
        return 'None'
      }
    }
  }
}
</script>

<style scoped>
  .categoriesGrid {display:grid; grid-template-columns: 30px 1fr 120px 75px; border-bottom: 1px solid #ccc;}
  .categoriesGrid:last-child {border-bottom:0;}
  .categoriesGrid .buttons button {padding:6px 10px;}
  .categoryName {padding-left:8px;}
  .input-row-button {display:grid; grid-template-columns: 1fr 1fr 60px; grid-gap: 8px;}

  .portfolioContentGrid {display:grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); grid-gap: 8px;}
  .cardImage {height:150px; width:100%; overflow:hidden; background-position: center; background-size: cover;}

  .headerRightGrid {display: grid; grid-template-columns: 1fr 115px; grid-gap:8px;}

  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsPortfolio.vue